import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.5 8l4 4l-4 4h4.5l4 -4l-4 -4l-4.5 0","key":"svg-0"}],["path",{"d":"M3.5 8l4 4l-4 4h4.5l4 -4l-4 -4l-4.5 0","key":"svg-1"}]]

/**
 * IconBrandInertia
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtaW5lcnRpYSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIuNSA4bDQgNGwtNCA0aDQuNWw0IC00bC00IC00bC00LjUgMCIgLz4KICA8cGF0aCBkPSJNMy41IDhsNCA0bC00IDRoNC41bDQgLTRsLTQgLTRsLTQuNSAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-inertia
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandInertia = createReactComponent('outline', 'brand-inertia', 'BrandInertia', __iconNode);

export default IconBrandInertia;